import { RentDocumentEntity } from 'backend-entity';

export type CrmGetRentDocumentsResponse = { rows: RentDocumentEntity[] };
